<template>
  <div class="page-container">
    <div class="stat-row">
      <div class="stat-card" v-for="s in stats" :key="s.label">
        <div class="stat-value" :style="{ color: s.color }">{{ s.value }}</div>
        <div class="stat-label">{{ s.label }}</div>
      </div>
    </div>

    <div class="search-box">
      <el-input v-model="params.keyword" placeholder="名称 / SN / 操作员" clearable style="width:220px" @keyup.enter.native="loadData" @clear="loadData" />
      <el-select v-model="params.factory_id" placeholder="厂区" clearable style="width:170px" @change="loadData">
        <el-option v-for="f in factories" :key="f.id" :label="f.name" :value="f.id" />
      </el-select>
      <el-select v-model="params.type" placeholder="类型" clearable style="width:130px" @change="loadData">
        <el-option label="叉车" :value="1" />
        <el-option label="特殊车辆" :value="2" />
        <el-option label="车辆" :value="3" />
      </el-select>
      <el-select v-model="params.status" placeholder="状态" clearable style="width:130px" @change="loadData">
        <el-option label="在线" :value="1" />
        <el-option label="离线" :value="2" />
        <el-option label="故障" :value="3" />
        <el-option label="未激活" :value="4" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="loadData">查询</el-button>
      <span class="spacer" />
      <el-button v-if="hasPermission('asset_batch')" :disabled="!selected.length" type="success" plain @click="batch(1)">批量启用</el-button>
      <el-button v-if="hasPermission('asset_batch')" :disabled="!selected.length" type="warning" plain @click="batch(2)">批量停用</el-button>
    </div>

    <div class="table-box">
      <el-table :data="tableData" border v-loading="loading" empty-text="暂无设备" height="100%" @selection-change="onSelect">
        <el-table-column type="selection" width="46" />
        <el-table-column prop="name" label="设备名称" min-width="120" />
        <el-table-column prop="sn" label="SN" min-width="130" />
        <el-table-column label="类型" width="100">
          <template slot-scope="scope">{{ ['叉车','特殊车辆','车辆'][scope.row.type-1] || '车辆' }}</template>
        </el-table-column>
        <el-table-column prop="factory_name" label="所属厂区" min-width="150" />
        <el-table-column label="状态" width="90">
          <template slot-scope="scope">
            <el-tag :type="statusTag(scope.row.status)" size="mini">{{ ['在线','离线','故障','未激活'][scope.row.status-1] }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="电量" width="110">
          <template slot-scope="scope">
            <span :style="{ color: scope.row.battery < 20 ? '#f53f3f' : '#1d2129' }">{{ scope.row.battery }}%</span>
          </template>
        </el-table-column>
        <el-table-column prop="speed" label="实时车速" width="90">
          <template slot-scope="scope">{{ scope.row.speed ? scope.row.speed + 'km/h' : '—' }}</template>
        </el-table-column>
        <el-table-column prop="operator" label="操作员" width="90" />
        <el-table-column prop="last_online" label="最后在线" min-width="150" />
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <el-link type="primary" @click="openDetail(scope.row)">详情</el-link>
            <el-link v-if="hasPermission('asset_edit')" type="primary" style="margin-left:10px" @click="openEdit(scope.row)">编辑</el-link>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-drawer :title="drawerTitle" :visible.sync="drawer" direction="rtl" size="480px" @close="resetForm">
      <div class="form-wrap">
        <el-form label-width="90px" v-if="detail">
          <el-form-item label="设备名称"><el-input v-model="form.name" :disabled="!editing" /></el-form-item>
          <el-form-item label="SN"><el-input v-model="form.sn" disabled /></el-form-item>
          <el-form-item label="类型">
            <el-select v-model="form.type" :disabled="!editing" style="width:100%">
              <el-option label="叉车" :value="1" /><el-option label="特殊车辆" :value="2" /><el-option label="车辆" :value="3" />
            </el-select>
          </el-form-item>
          <el-form-item label="所属厂区"><el-input v-model="form.factory_name" disabled /></el-form-item>
          <el-form-item label="状态">
            <el-select v-model="form.status" :disabled="!editing" style="width:100%">
              <el-option label="在线" :value="1" /><el-option label="离线" :value="2" /><el-option label="故障" :value="3" /><el-option label="未激活" :value="4" />
            </el-select>
          </el-form-item>
          <el-form-item label="操作员"><el-input v-model="form.operator" :disabled="!editing" /></el-form-item>
          <el-form-item label="SIM卡"><el-input v-model="form.sim" :disabled="!editing" /></el-form-item>
          <el-form-item label="固件版本"><el-input v-model="form.firmware" :disabled="!editing" /></el-form-item>
          <el-form-item label="累计里程"><el-input :value="form.mileage + ' km'" disabled /></el-form-item>
          <el-form-item label="最后在线"><el-input v-model="form.last_online" disabled /></el-form-item>
        </el-form>
        <div class="drawer-foot" v-if="editing">
          <el-button @click="editing = false">取消</el-button>
          <el-button type="primary" :loading="saving" @click="save">保存</el-button>
        </div>
        <div class="drawer-foot" v-else>
          <el-button @click="drawer = false">关闭</el-button>
          <el-button v-if="hasPermission('asset_edit')" type="primary" @click="editing = true">编辑资料</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { getAssets, getFactories, updateAsset, batchAssetAction } from '@/api/sentinel'

export default {
  name: 'AssetIndex',
  data() {
    return {
      params: { keyword: '', factory_id: '', type: '', status: '' },
      tableData: [],
      total: 0,
      loading: false,
      stats: [],
      factories: [],
      selected: [],
      drawer: false,
      drawerTitle: '设备详情',
      detail: null,
      editing: false,
      saving: false,
      form: {}
    }
  },
  mounted() {
    getFactories().then(res => { if (res.code === 200) this.factories = (res.data && res.data.list) || [] })
    this.loadData()
  },
  methods: {
    hasPermission(k) { return this.$store.getters.hasPermission(k) },
    statusTag(s) { return ['success', 'info', 'danger', 'warning'][s - 1] },
    loadData() {
      this.loading = true
      getAssets(this.params).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.list || []
          this.total = res.data.total || 0
          this.stats = [
            { label: '设备总数', value: res.data.stat.total, color: '#165dff' },
            { label: '在线', value: res.data.stat.online, color: '#00b42a' },
            { label: '离线', value: res.data.stat.offline, color: '#86909c' },
            { label: '故障', value: res.data.stat.fault, color: '#f53f3f' },
            { label: '未激活', value: res.data.stat.inactive, color: '#ff7d00' }
          ]
        }
      }).finally(() => { this.loading = false })
    },
    onSelect(rows) { this.selected = rows },
    batch(status) {
      const ids = this.selected.map(r => r.id)
      batchAssetAction(ids, status === 1 ? 'enable' : 'disable').then(res => {
        if (res.code === 200) { this.$message.success('批量操作成功'); this.loadData() }
      })
    },
    openDetail(row) {
      this.drawerTitle = '设备详情'
      this.detail = row
      this.form = { ...row }
      this.editing = false
      this.drawer = true
    },
    openEdit(row) {
      this.drawerTitle = '编辑设备'
      this.detail = row
      this.form = { ...row }
      this.editing = true
      this.drawer = true
    },
    resetForm() { this.detail = null; this.form = {}; this.editing = false },
    save() {
      this.saving = true
      updateAsset(this.form.id, { name: this.form.name, type: this.form.type, status: this.form.status, operator: this.form.operator, sim: this.form.sim, firmware: this.form.firmware })
        .then(res => {
          if (res.code === 200) { this.$message.success('保存成功'); this.editing = false; this.loadData() }
        }).finally(() => { this.saving = false })
    }
  }
}
</script>

<style scoped>
.stat-row { display: flex; gap: 14px; margin-bottom: 16px; flex-wrap: wrap; }
.stat-card { flex: 1; min-width: 110px; background: #fff; border-radius: 4px; padding: 14px 18px; box-shadow: 0 2px 12px rgba(0,0,0,.08); }
.stat-value { font-size: 26px; font-weight: 700; }
.stat-label { font-size: 13px; color: #86909c; margin-top: 4px; }
.search-box { display: flex; align-items: center; gap: 12px; margin-bottom: 16px; flex-wrap: wrap; }
.search-box .spacer { flex: 1; }
.table-box { background: #fff; padding: 16px; border-radius: 4px; box-shadow: 0 2px 12px rgba(0,0,0,.1); }
.form-wrap { padding: 8px 16px; }
.drawer-foot { display: flex; justify-content: flex-end; gap: 12px; margin-top: 20px; }
</style>
